import React from 'react'

const Nodejs_Coding_Pratice_5 = () => {
  return (
    <div>
      <h1>Coding Pratice 5</h1>
    </div>
  )
}

export default Nodejs_Coding_Pratice_5
